import React from 'react'
import { sanitizeHtmlAndReplaceNewlines } from '../utilities/string'

export interface ParagraphProps {
  children?: string
  className?: string
}

/**
 * A paragraph component that supports linebreaks using [\r]\n. Should ideally be used on fields from Sanity
 * of schema type 'text'.
 */
export const Paragraph = ({ children, className }: ParagraphProps) =>
  children ? (
    <p
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtmlAndReplaceNewlines(children),
      }}
    />
  ) : null
